import React, { useState } from 'react';

import styles from "../AddNewFile.module.css"

import Dropdown from 'react-bootstrap/Dropdown';

//Images
import arrowDown from "../../../../assets/img/DashboardICons/ArrowDown.svg"

const city = [
    {
        id: 1,
        name: "تبریز",
    },
    {
        id: 2,
        name: "تهران",
    },
    {
        id: 3,
        name: "اصفهان",
    },
    {
        id: 4,
        name: "کرج",
    },
    {
        id: 5,
        name: "شیراز",
    }

]

const place = [
    {
        id: 1,
        name: "ولیعصر",
    },
    {
        id: 2,
        name: "پاستور",
    },
    {
        id: 3,
        name: "آبرسان",
    },
    {
        id: 4,
        name: "شریعتی",
    },
    {
        id: 5,
        name: "بازار",
    }

]

const year = [
    {
        id: 1,
        name: "1380",
    },
    {
        id: 2,
        name: "1381",
    },
    {
        id: 3,
        name: "1382",
    },
    {
        id: 4,
        name: "1383",
    },
    {
        id: 5,
        name: "1384",
    },
    {
        id: 6,
        name: "1385",
    },
    {
        id: 7,
        name: "1386",
    },
    {
        id: 8,
        name: "1387",
    },
    {
        id: 9,
        name: "1388",
    },
    {
        id: 10,
        name: "1389",
    },
    {
        id: 11,
        name: "1390",
    },
    {
        id: 12,
        name: "1391",
    },
    {
        id: 13,
        name: "1392",
    },
    {
        id: 14,
        name: "1393",
    },
    {
        id: 15,
        name: "1394",
    },
    {
        id: 16,
        name: "1395",
    },
    {
        id: 17,
        name: "1396",
    },
    {
        id: 18,
        name: "1397",
    },
    {
        id: 19,
        name: "1398",
    },
    {
        id: 20,
        name: "1399",
    },
    {
        id: 21,
        name: "1400",
    },
    {
        id: 22,
        name: "1401",
    },
    {
        id: 23,
        name: "1402",
    },
]

const room = [
    {
        id: 0,
        name: "0",
    },
    {
        id: 1,
        name: "1",
    },
    {
        id: 2,
        name: "2",
    },
    {
        id: 3,
        name: "3",
    },
    {
        id: 4,
        name: "4",
    },
    {
        id: 5,
        name: "5",
    }

]

const floor = [
    {
        id: -1,
        name: "زیرزمین",
    },
    {
        id: 0,
        name: "همکف",
    },
    {
        id: 1,
        name: "1",
    },
    {
        id: 2,
        name: "2",
    },
    {
        id: 3,
        name: "3",
    },
    {
        id: 4,
        name: "4",
    },
    {
        id: 5,
        name: "5",
    },

]

const userYear = [
    {
        id: 1,
        name: "کمتر از 5 سال",
    },
    {
        id: 2,
        name: "بیشتر از 5 سال",
    },
    {
        id: 3,
        name: "فرقی نمیکند",
    },
]

const region = [
    {
        id: 1,
        name: "ایران",
    },
    {
        id: 2,
        name: "ترکیه",
    },
    {
        id: 3,
        name: "قبرس",
    },
]

const currency = [
    {
        id: 1,
        name: "تومان",
    },
    {
        id: 2,
        name: "لیر",
    },
    {
        id: 3,
        name: "دلار",
    },
    {
        id: 4,
        name: "پوند",
    },
]

const AddNewFileDropdown = (props) => {
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    const [state, setstate] = useState(false)

    const titleHandler = (event) => {
        props.setDropDownsData((prev) => {
            return { ...prev, [event.target.id]: event.target.name };
        });
    }

    return (
        <>

            <style type="text/css">
                {`
    .dropdown-toggle {
        width: 247px;
        height: 48px;
        background: #f9f9f9;
        border: 1px solid #e2e2e2;
        border-radius: 34px;
        margin-left: ${props.userAdd ? "0" : "0.75rem"};
        color: #1D1D1D;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .dropdown-toggle:after,
    .btn-success:after {
        content: none;
    }
    
    .btn-success {
        background: #f9f9f9 !important;
        border: 1px solid #E1E1E1 !important;
        color: #8D8D8D !important;
        box-shadow: none !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
    }

    .dropdown-menu {
        width: 247px;
        height: 190px !important;
        padding-right: 0.75rem;
        overflow-y: scroll;
        background: #F9F9F9;
        border: 1px solid #E1E1E1;
        border-radius: 34px;
    }

   .dropdown-menu::-webkit-scrollbar{
    width: 4px;
    height: 60px;
    }
    
    .dropdown-menu::-webkit-scrollbar-track {
        background: transparent;
        margin-block: 10px;
    }

    .dropdown-menu::-webkit-scrollbar-thumb {
        background: #B4B4B4;
        border-radius: 20px;
    }

    .dropdown-item {
        margin: .5rem 0;
        padding: .5rem .5rem .5rem 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #363636;
    }

    .dropdown-item:hover {
        background: transparent !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #21409A;
    }
    `}
            </style>

            <div className={`py-2 ${props.noFloorMargin && "me-md-2"} me-0 ${props.country ? "mb-4" : ""}`}>
                <div className={`${props.userAdd ? "" : "container-fluid"}`}>
                    <div
                        className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "mt-2" : "mt-3 me-1"}`}
                        dir="rtl"
                    >
                        {
                            <div className="d-flex align-items-start justify-content-center flex-column">
                                <div className={`mb-2 ${styles.submenu_title}`}>
                                    {
                                        props.city === true ? "شهر"
                                            :
                                            props.place === true ? "منطقه"
                                                :
                                                props.userRequest && props.year ? "عمر ساخت" : props.year === true ? "سال ساخت" : props.year === true ? "سال ساخت"
                                                    :
                                                    props.room === true ? "تعداد اتاق خواب"
                                                        :
                                                        props.floor === true ? "طبقه"
                                                            :
                                                            props.region === true ? "منطقه جغرافیایی"
                                                                :
                                                                props.currency === true && "واحد ارزی"
                                    }
                                </div>
                                <Dropdown dir='rtl'>
                                    {
                                        props.city === true ?
                                            <Dropdown.Toggle className="px-3" variant="success" id="dropdown-basic">
                                                {
                                                    props.cityName !== "" ? props.cityName
                                                        :
                                                        props.cityName == "" ? " انتخاب شهر"
                                                            :
                                                            props.dropDownsData?.city !== "" && props.dropDownsData?.city
                                                }
                                                <img className='me-3' src={arrowDown} alt="icon" />
                                            </Dropdown.Toggle>
                                            :
                                            props.place === true ?
                                                <Dropdown.Toggle className="px-3" variant="success" id="dropdown-basic">
                                                    {
                                                        props.placeName !== "" ? props.placeName
                                                            :
                                                            props.placeName == "" ? " انتخاب منطقه"
                                                                :
                                                                props.dropDownsData?.place !== "" && props.dropDownsData?.place
                                                    }
                                                    <img className='me-3' src={arrowDown} alt="icon" />
                                                </Dropdown.Toggle>
                                                :
                                                props.year === true ?
                                                    <Dropdown.Toggle className="px-3" variant="success" id="dropdown-basic">
                                                        {
                                                            props.yearName !== "" ? e2p(props.yearName?.toString())
                                                                :
                                                                props.yearName == "" ? " انتخاب سال ساخت"
                                                                    :
                                                                    props.dropDownsData?.year !== "" && props.dropDownsData?.year
                                                        }
                                                        <img className='me-3' src={arrowDown} alt="icon" />
                                                    </Dropdown.Toggle>
                                                    :
                                                    props.room === true ?
                                                        <Dropdown.Toggle className="px-3" variant="success" id="dropdown-basic">
                                                            {
                                                                props.roomNumber == "0" ? "۰"
                                                                    :
                                                                    props.roomNumber !== "" ? e2p(props.roomNumber?.toString())
                                                                        :
                                                                        props.roomNumber == "" ? " تعداد اتاق خواب"
                                                                            :
                                                                            props.dropDownsData?.room !== "" && props.dropDownsData?.room
                                                            }

                                                            <img className='me-3' src={arrowDown} alt="icon" />
                                                        </Dropdown.Toggle>
                                                        :
                                                        props.floor === true ?
                                                            <Dropdown.Toggle className="px-3" variant="success" id="dropdown-basic">
                                                                {
                                                                    props.floorNumber == "-1" ? "زیرزمین"
                                                                        :
                                                                        props.floorNumber == "0" ? "همکف"
                                                                            :
                                                                            props.floorNumber !== "" ? e2p(props.floorNumber?.toString())
                                                                                :
                                                                                props.floorNumber == "" ? " طبقه"
                                                                                    :
                                                                                    props.dropDownsData?.floor !== "" && props.dropDownsData?.floor
                                                                }
                                                                <img className='me-3' src={arrowDown} alt="icon" />
                                                            </Dropdown.Toggle>
                                                            :
                                                            props.region === true ?
                                                                <Dropdown.Toggle className="px-3" variant="success" id="dropdown-basic">
                                                                    {
                                                                        props.regionName == "1" ? "ایران"
                                                                            :
                                                                            props.regionName == "2" ? "ترکیه"
                                                                                :
                                                                                props.regionName == "3" ? "قبرس"
                                                                                    :
                                                                                    props.regionName !== "" ? e2p(props.regionName?.toString())
                                                                                        :
                                                                                        props.regionName == "" ? " منطقه جغرافیایی"
                                                                                            :
                                                                                            props.dropDownsData?.region !== "" && props.dropDownsData?.region
                                                                    }
                                                                    <img className='me-3' src={arrowDown} alt="icon" />
                                                                </Dropdown.Toggle>
                                                                :
                                                                props.currency === true &&
                                                                <Dropdown.Toggle className="px-3" variant="success" id="dropdown-basic">
                                                                    {
                                                                        props.currencyName == "1" ? "تومان"
                                                                            :
                                                                            props.currencyName == "2" ? "لیر"
                                                                                :
                                                                                props.currencyName == "3" ? "دلار"
                                                                                    :
                                                                                    props.currencyName == "4" ? "پوند"
                                                                                        :
                                                                                        props.currencyName !== "" ? e2p(props.currencyName?.toString())
                                                                                            :
                                                                                            props.currencyName == "" ? "واحد ارزی"
                                                                                                :
                                                                                                props.dropDownsData?.currency !== "" && props.dropDownsData?.currency
                                                                    }
                                                                    <img className='me-3' src={arrowDown} alt="icon" />
                                                                </Dropdown.Toggle>
                                    }

                                    {
                                        props.city === true ?
                                            <Dropdown.Menu show={state ? true : false}>
                                                {city?.map((cityItem) => (
                                                    <Dropdown.Item className="px-3" id="city" key={cityItem.id} name={cityItem.name} onClick={titleHandler}>
                                                        {cityItem.name}
                                                    </Dropdown.Item>
                                                ))}
                                                <Dropdown.Item className="px-3" onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation()
                                                    setstate(true)
                                                }} >
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        value={props.dropDownsData?.city}
                                                        onChange={changeHandler}
                                                        className={styles.manualy_added_data_input}
                                                    />
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                            :
                                            props.place === true ?
                                                <Dropdown.Menu >
                                                    {place?.map((placeItem) => (
                                                        <Dropdown.Item className="px-3" id="place" key={placeItem.id} name={placeItem.name} onClick={titleHandler}>
                                                            {placeItem.name}
                                                        </Dropdown.Item>
                                                    ))}
                                                    <Dropdown.Item className="px-3" onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation()
                                                        setstate(true)
                                                    }} >
                                                        <input
                                                            type="text"
                                                            name="place"
                                                            value={props.dropDownsData?.place}
                                                            onChange={changeHandler}
                                                            className={styles.manualy_added_data_input}
                                                        />
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                                :
                                                props.year === true ?
                                                    <Dropdown.Menu>
                                                        {props.userRequest ?
                                                            userYear?.map((yearItem) => (
                                                                <Dropdown.Item className="px-3" id="year" key={yearItem.id} name={yearItem.name} onClick={titleHandler}>
                                                                    {yearItem.name?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                                                </Dropdown.Item>
                                                            ))
                                                            :
                                                            year?.map((yearItem) => (
                                                                <Dropdown.Item className="px-3" id="year" key={yearItem.id} name={yearItem.name} onClick={titleHandler}>
                                                                    {yearItem.name?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                                                </Dropdown.Item>
                                                            ))}
                                                        {props.userRequest ?
                                                            <></>
                                                            :
                                                            <Dropdown.Item className="px-3" onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation()
                                                                setstate(true)
                                                            }} >
                                                                <input
                                                                    type="number"
                                                                    name="year"
                                                                    value={props.dropDownsData?.year}
                                                                    onChange={changeHandler}
                                                                    className={styles.manualy_added_data_input}
                                                                />
                                                            </Dropdown.Item>}
                                                    </Dropdown.Menu>
                                                    :
                                                    props.room === true ?
                                                        <Dropdown.Menu>
                                                            {room?.map((roomItem) => (
                                                                <Dropdown.Item className="px-3" id="room" key={roomItem.id} name={roomItem.name} onClick={titleHandler}>
                                                                    {roomItem.name}
                                                                </Dropdown.Item>
                                                            ))}
                                                            {props.userRequest &&
                                                                <Dropdown.Item className="px-3" id="room" name={"فرقی ندارد"} onClick={titleHandler}>
                                                                    {"فرقی ندارد"}
                                                                </Dropdown.Item>
                                                            }
                                                            <Dropdown.Item className="px-3" onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation()
                                                                setstate(true)
                                                            }} >
                                                                <input
                                                                    type="number"
                                                                    name="room"
                                                                    value={props.dropDownsData?.room}
                                                                    onChange={changeHandler}
                                                                    className={styles.manualy_added_data_input}
                                                                />
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                        :
                                                        props.floor === true ?
                                                            <Dropdown.Menu>
                                                                {floor?.map((floorItem) => (
                                                                    <Dropdown.Item className="px-3" id="floor" key={floorItem.id} name={floorItem.name} onClick={titleHandler}>
                                                                        {floorItem.name}
                                                                    </Dropdown.Item>
                                                                ))}
                                                                {props.userRequest &&
                                                                    <Dropdown.Item className="px-3" id="floor" name={"فرقی ندارد"} onClick={titleHandler}>
                                                                        {"فرقی ندارد"}
                                                                    </Dropdown.Item>
                                                                }
                                                                <Dropdown.Item className="px-3" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation()
                                                                    setstate(true)
                                                                }} >
                                                                    <input
                                                                        type="number"
                                                                        name="floor"
                                                                        value={props.dropDownsData?.floor}
                                                                        onChange={changeHandler}
                                                                        className={styles.manualy_added_data_input}
                                                                    />
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                            :
                                                            props.region === true ?
                                                                <Dropdown.Menu show={state ? true : false}>
                                                                    {region?.map((regionItem) => (
                                                                        <Dropdown.Item className="px-3" id="region" key={regionItem.id} name={regionItem.name} onClick={titleHandler}>
                                                                            {regionItem.name}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                    <Dropdown.Item className="px-3" onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation()
                                                                        setstate(true)
                                                                    }} >
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                                :
                                                                props.currency === true &&
                                                                <Dropdown.Menu show={state ? true : false}>
                                                                    {currency?.map((currency) => (
                                                                        <Dropdown.Item className="px-3" id="currency" key={currency.id} name={currency.name} onClick={titleHandler}>
                                                                            {currency.name}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                    <Dropdown.Item className="px-3" onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation()
                                                                        setstate(true)
                                                                    }} >
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                    }
                                </Dropdown>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );

    function changeHandler(event) {
        if (event.target.name === "room") {
            const newValue = event.target.value;
            if (newValue > 10) {
                props.setDropDownsData((prev) => {
                    return { ...prev, [event.target.name]: 10 };
                });
            } else {
                props.setDropDownsData((prev) => {
                    return { ...prev, [event.target.name]: newValue };
                });
            }
        } else if (event.target.name === "floor") {
            const newValue = parseInt(event.target.value);
            if (newValue <= 20) {
                props.setDropDownsData((prev) => {
                    return { ...prev, [event.target.name]: event.target.value };
                });
            }
        }
        else {
            props.setDropDownsData((prev) => {
                return { ...prev, [event.target.name]: event.target.value };
            });
        }
    };
};

export default AddNewFileDropdown;